export default __webpack_public_path__ + "static/media/footer_protocol_prompt.3f54dc08.png";